import React, { useEffect } from 'react';
import { get, shuffle } from 'lodash';
import { getMentoringReviews } from 'libs/api/mentoring';
import { useDataApi, usePagination } from 'libs/hooks';
import { TMentoringReview } from 'modules/mentoring';
import { TListResponse, TModalProps, TPagination } from 'modules/types';
import { Modal, Typography, List } from 'antd';
import blurPage from 'assets/images/pages/community/blurImg.png';
import styled from 'styled-components';

const { Text, Title } = Typography;
const MentoringReviewsModalWrapper = styled.div`
  font-size: 16px;
  color: #000;

  .small-btn {
    margin: 10px 5px;
    padding: 0px 12px !important;
  }
  .ant-divider {
    margin: 35px 0px !important;
  }
  .icon {
    margin-bottom: 5px;
    margin-right: 7px;
  }

  .card {
    /* Add shadows to create the "card" effect */
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    transition: 0.3s;
    position: absolute;
    top: 55%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 40px 10px;
  }
`;

const MentoringReviewsModal = ({ modalState, setModalState }: TModalProps) => {
  const [pagination, setPagination] = usePagination(8);
  const reloadPage = (page?: Partial<TPagination>) => {
    setPagination({
      ...pagination,
      ...page,
    });
  };
  const getPromiseReviews = getMentoringReviews.bind(null, get(modalState, 'record'), {
    params: {
      current: pagination.current,
      pageSize: pagination.pageSize,
      ordering: pagination.ordering,
    },
  });
  const [{ data: reviews, loading: reviewsLoading }, setCallbackReviews] = useDataApi<
    TListResponse<TMentoringReview>
  >(getPromiseReviews, {
    contents: [],
    last: false,
  });

  useEffect(() => {
    if (modalState.visible) {
      console.log('MentoringReviewsModal pagination')
      setCallbackReviews(() => getPromiseReviews);
    }
  }, [pagination]);

  useEffect(() => {
    if (modalState.visible) {
      console.log('MentoringReviewsModal')
      setCallbackReviews(() => getPromiseReviews);
    }
  }, [modalState.visible]);

  function handleCancel() {
    setModalState({ visible: false });
  }

  return (
    <MentoringReviewsModalWrapper>
      <Modal
        visible={modalState.visible}
        maskClosable={true}
        closable={true}
        width={800}
        centered={true}
        title={
          <Title level={4} style={{ marginBottom: '0px' }}>
            수강후기
          </Title>
        }
        onCancel={handleCancel}
      >
        {
          reviews.total < 5 ? 
          <img src={blurPage} alt=''  /> 
          :
        <List
          split={false}
          dataSource={ pagination.current === 1 ? shuffle(get(reviews, 'contents', [])) : get(reviews, 'contents', [])}
          pagination={{
            ...pagination,
            total: get(reviews, 'total', 0),
            position: 'bottom',
            hideOnSinglePage: true,
            onChange: (page) => {
              reloadPage({
                current: page,
                pageSize: pagination.pageSize,
              });
            },
          }}
          renderItem={(item) => (
            <List.Item>
              <List.Item.Meta
                title={<div className='title'>{get(item, 'comment')}</div>}
                avatar={<img width='40px' alt='logo' src='https://bigstep-backend-media.s3.ap-northeast-2.amazonaws.com/media/image/2020-11-18/asqziyxodp64KoMS5wbmc.png' />}
              />
            </List.Item>
          )}
        />
        }
      </Modal>
    </MentoringReviewsModalWrapper>
  );
};

export default MentoringReviewsModal;
